import { atom } from '@reatom/framework'

import type { OpenTradeSettingsDialogParams } from '@root/features/trade/trade-settings'

export const tradeSettingsDialogParamsAtom = atom<
  OpenTradeSettingsDialogParams | undefined
>(undefined, 'tradeSettingsDialogParamsAtom')
